<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import { useAuthStore } from '@/stores/auth'
import { usePermissionsStore } from '@/stores/permissions'
import { useSettingsStore } from '@/stores/settings'
import FosToast from '@/components/ui/FosToast.vue'
import AlphaGate from '@/components/AlphaGate.vue'
import { TooltipProvider } from 'radix-vue'

const authStore = useAuthStore()
const permissionsStore = usePermissionsStore()
const settingsStore = useSettingsStore()

const betaPassword = import.meta.env.VITE_BETA_PASSWORD as string | undefined
const betaUnlocked = ref(!betaPassword || localStorage.getItem('beta_unlocked') === 'true')

onMounted(() => {
  authStore.initAuth()
  settingsStore.applyTheme()

  // Subscribe to permissions once auth is ready (works offline via IndexedDB)
  const stop = watch(
    () => authStore.authReady,
    (ready) => {
      if (ready) {
        permissionsStore.subscribe()
        stop()
      }
    },
    { immediate: true },
  )
})
</script>

<template>
  <AlphaGate v-if="!betaUnlocked" @unlocked="betaUnlocked = true" />
  <TooltipProvider v-else :delay-duration="300">
    <RouterView />
    <FosToast />
  </TooltipProvider>
</template>
